import React from 'react';
import { TenantSetupTab } from './TenantSetupTab';

export const SetupTab: React.FC = () => {
  return (
    <div className='w-full h-full flex flex-col'>
      <TenantSetupTab />
    </div>
  );
};
